import type { GroupIconType } from "@/components/GroupIcon/GroupIcon";
import { GroupIcon } from "@/components/GroupIcon/GroupIcon";
import { Icon54 } from "@/components/Icon54/Icon54";

import type { MediaBaseProps } from "./Media";
import { Media } from "./Media";

export interface IconMediaProps extends MediaBaseProps {
  charCode: number | undefined;
}

export function IconMedia({ charCode, ...props }: IconMediaProps): React.ReactNode {
  return (
    <Media {...props}>
      {typeof charCode === "number" ? <Icon54 appearance="media" charCode={charCode} disableUserSelect /> : null}
    </Media>
  );
}

interface GroupIconMediaProps extends MediaBaseProps {
  icon: GroupIconType | undefined;
}

export function GroupIconMedia({ icon, ...props }: GroupIconMediaProps): React.ReactNode {
  return (
    <Media {...props}>
      {icon ? (
        <span className="flex size-full items-center justify-center p-space-sm">
          <GroupIcon size={48} icon={icon} />
        </span>
      ) : null}
    </Media>
  );
}
